export const categories = [
    {path: '/', name: 'Home'},
    {path: '/about', name: 'About'},
    {path: '/celeste', name: 'Celeste (Project details)'},
    {path: '/our-projects', name: 'Our Projects'},
    {path: '/contact', name: 'Contact Us'},
]